import _ from 'lodash';
import * as types from '../mutation-types';
import { setting } from '../../api/';

const state = {
  settings: [],
};

const getters = {
  getSettingByKey: s => key => _.get(s, key),
};

const actions = {
  fetchSettings({ commit }) {
    return setting.get().then(({ data: response }) => {
      commit(types.RECEIVE_SETTINGS, response);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_SETTINGS](s, response) {
    response.data.forEach((item) => {
      const num = Number(item.value);
      s[item.key] = _.isNaN(num) ? item.value : num;
      s.settings[item.key] = _.isNaN(num) ? item.value : num;
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/setting.js